<template>
	<Upload/>
</template>

<script>
// @ is an alias to /src
import Upload from '@/components/Course/Upload.vue'

export default {
  name: 'course',
  components: {
    Upload
  }
}
</script>
